export default __webpack_public_path__ + "static/media/arrow.8121cb6b.svg";